module.exports = __webpack_public_path__ + "img/car.3ec864ba.png";